module.exports = __webpack_public_path__ + "img/yaprak.07241544.png";